import React from 'react';
import {Link} from 'react-router-dom';
import Moment from 'react-moment';
import 'moment-timezone';
import Navigation from '../Navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faStar } from '@fortawesome/free-solid-svg-icons'
import logo from '../../images/new_logo.svg';
import { isNotEmpty } from "../../util/user";

export default class PropertyAlgolia extends React.Component {
  constructor(props) {
    super(props);
  }

  addDefaultSrc(ev) {
    ev.target.src = logo;
  }

  render() {
    const result = this.props.result;
    const id = result.objectID.replace("property-", "")
    const listingKey = result.ListingId
    let image = result.Image
    image = image.replace("-dev", "-prod")
    // should be slug

    return (
      <div className="job-outline property-outline">
        <Link to={"/listings/"+listingKey}>
          <img onError={this.addDefaultSrc} src={image} />

          <div className="property-info">
            <h2>{result.StreetAddress}</h2>
            <h3>{result.City}, Ontario {result.PostalCode}</h3>
            <h3 className="price">${parseInt(result.ListPrice).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</h3>
          </div>
        </Link>
      </div>
    )
  }
}
